<template>
    <div class="c_meeting_link_container">
        <div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
            <!-- :gutter="24" -->
        <a-row  type="flex" style="margin-top: -170px;margin-right: 2%;margin-left: 3%">
            <a-col :span="24" class="mb-24" style="padding-left: 0px;padding-right: 0px">
                <height-watcher>
                    <div
                        class="budgets-page-body"
                        slot-scope="{ height, offset }"
                        :offset="offset"
                        :style="{
                            'max-height': height - (450) + 'px',
                            height: height - (450) + 'px',
                        }"
                    >
                        <a-card :bordered="false" class="card-profile-head " :bodyStyle="{padding: 0}">		
                            <CardMeetingsLink />
                        </a-card>
                    </div>
                </height-watcher>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import CardMeetingsLink from "../../components/Cards/CardMeetingsLinkTable.vue";
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue";
export default {
    name: "MeetingsLink",
    components: {
        CardMeetingsLink,
        HeightWatcher
    }
}
</script>

<style>

</style>